import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { LoadingScreenComponent } from '../../shared/loading-screen/loading-screen.component';


@Component({
  standalone: true,
  selector: 'app-logout',
  imports: [LoadingScreenComponent],
  // Shown for the moment between the auth server's sign out and the redirect to its sign in page
  template: `<app-loading-screen statusKey="LOADING_SCREEN.SIGNING_OUT" />`,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LogoutComponent {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  constructor() {
    sessionStorage.clear()
    localStorage.clear();

    // Redirect to login
    this.oidcSecurityService.authorize();
  }
}
